export default "__VITE_ASSET__f6981e73__"